// environment.ts
export const apiEndpoint = process.env.REACT_APP_BASE_URL;
export const AUTH_TOKEN = "authToken";
export const BEARER = "Bearer";